import { PostRequest } from "../../services/ApiClientService"
import { API_ROUTES } from "../../configuration/RoutesApi"
import type { SignInResponseDto } from "../../Objects/Generics/SignInResponseDto"

export interface SignUpResellerRequest {
  name: string
  email: string
  password: string
  phoneNumber: string
  documentCpfCnpj: string
}

export interface SignInResellerRequest {
  username: string
  password: string
}

export const useResellerAuth = () => {
  const persistSession = (data: SignInResponseDto) => {
    localStorage.setItem(API_ROUTES.TOKEN_RESELLER, JSON.stringify(data.token))
  }

  const handleSignUpReseller = async (request: SignUpResellerRequest) => {
    const response = await PostRequest<SignInResponseDto>(API_ROUTES.AUTH.RESELLER_SIGNUP, request)

    if (!response.success || !response.data?.token) {
      throw new Error(response.message)
    }

    persistSession(response.data)

    return response.data
  }

  const handleSignInReseller = async (request: SignInResellerRequest) => {
    const response = await PostRequest<SignInResponseDto>(API_ROUTES.AUTH.RESELLER_LOGIN, request)

    if (!response.success || !response.data?.token) {
      throw new Error(response.message)
    }

    persistSession(response.data)

    return response.data
  }

  return { handleSignUpReseller, handleSignInReseller }
}
